import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectFieldOptions,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import { Card, Col, Row } from 'reactstrap'
import { CONDITION, PER_PAGE, RECEIVED_STATUS, SORT_BY, SORT_DIR, STATUS } from 'domains/fast-sell-product/constants'
import { FastSellProductCategorySelectField } from 'domains/fast-sell-product/components'

const propTypes = {
  filterValues       : PropTypes.object,
  onClickSubmitForm  : PropTypes.func,
  onClickReset       : PropTypes.func,
  fastSellBrands     : PropTypes.array,
  fastSellCategories : PropTypes.array
}

const defaultProps = {
  onClickSubmitForm : () => { },
  onClickReset      : () => { }
}

const FastSellProductFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset,
  fastSellBrands
}) => (
  <Formik
    initialValues={{
      name                : filterValues.name || '',
      seller_name         : filterValues.seller_name || '',
      mobile              : filterValues.mobile || '',
      email               : filterValues.email || '',
      condition           : filterValues.condition || '',
      product_category_id : filterValues.product_category_id || '',
      product_brand_id    : filterValues.product_brand_id || '',
      status              : filterValues.status || '',
      received_status     : filterValues.received_status || '',
      per_page            : filterValues.per_page || '',
      sort_by             : filterValues.sort_by || '',
      sort_dir            : filterValues.sort_dir || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      ({ isSubmitting }) => (
        <Form>
          <Card body>
            <Row>
              <Col>
                <InputField
                  type='input'
                  name='seller_name'
                  label='Nama Seller'
                  placeholder="Cari dengan nama Seller.."
                />
                <InputField
                  type='input'
                  name='mobile'
                  label="No. HP Seller"
                  placeholder="Cari dengan no. HP Seller"
                />
                <InputField
                  type='input'
                  name='email'
                  label="Email"
                  placeholder="Cari dengan email Seller"
                />
              </Col>

              <Col>
                <InputField
                  type='input'
                  name='name'
                  label='Nama Produk'
                  placeholder="Cari dengan nama produk.."
                />
                <InputField
                  type={ 'select' }
                  name={ 'condition' }
                  label={ 'Kondisi' }
                >
                  <InputSelectOptions
                    options={ CONDITION }
                  />
                </InputField>
              </Col>

              <Col>
                <FastSellProductCategorySelectField
                  inline
                  name={ 'product_category_id' }
                  label={ 'Kategori' }
                />

                <InputField
                  type='select'
                  name='product_brand_id'
                  label='Brand'
                >
                  <option label='Choose One' value='' />
                  <InputSelectFieldOptions
                    options={ fastSellBrands }
                  />
                </InputField>
              </Col>

              <Col>
                <InputField
                  type={ 'select' }
                  name={ 'status' }
                  label='Status'
                >
                  <InputSelectOptions
                    options={ STATUS }
                  />
                </InputField>
                <InputField
                  type={ 'select' }
                  name={ 'received_status' }
                  label='Received Status'
                >
                  <InputSelectOptions
                    options={ RECEIVED_STATUS }
                  />
                </InputField>
              </Col>
            </Row>

            <div className='d-flex justify-content-end'>
              <InputField
                type={ 'select' }
                formGroupClassName={ 'mr-3' }
                name={ 'sort_by' }
                label={ 'Sort By' }
                bsSize={ 'sm' }
              >
                <InputSelectOptions
                  options={ SORT_BY }
                />
              </InputField>

              <InputField
                type={ 'select' }
                formGroupClassName={ 'mr-3' }
                name={ 'sort_dir' }
                label={ 'Sort Dir' }
                bsSize={ 'sm' }
              >
                <InputSelectOptions
                  options={ SORT_DIR }
                />
              </InputField>

              <InputField
                type={ 'select' }
                name={ 'per_page' }
                label={ 'Per Page' }
                bsSize={ 'sm' }
              >
                <InputSelectOptions
                  options={ PER_PAGE }
                />
              </InputField>
            </div>

            <div className='d-flex'>
              <LoaderButton
                color='primary'
                className='mt-auto'
                type='submit'
                disabled={ isSubmitting }
                isLoading={ isSubmitting }
                text='Filter'
              />
              <LoaderButton
                color='danger'
                disabled={ isSubmitting }
                isLoading={ isSubmitting }
                text='Reset'
                onClick={ onClickReset }
              />

            </div>
          </Card>
        </Form>
      )
    }
  </Formik>
)

FastSellProductFilterForm.propTypes    = propTypes
FastSellProductFilterForm.defaultProps = defaultProps

export default FastSellProductFilterForm
